__turbopack_context__.v({
  "banner": "RewardsGetStartedBanner-module__-0Pz8a__banner",
  "cta": "RewardsGetStartedBanner-module__-0Pz8a__cta",
  "heading": "RewardsGetStartedBanner-module__-0Pz8a__heading",
});
